import React, { useContext, useEffect, useState } from "react";
import "../../Style/createstyle.scss";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Grid, Stack, Box, TextField, Typography, Button } from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
//Src
import { AuthContext } from "../../Context/AuthContext";
import { CREATE_MAJOR, UPDATE_MAJOR } from "../../Schema/Major";

export default function CreateMajor({
  open,
  handleClose,
  dialogTitle,
  editData,
  setRefetch,
}) {
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createMajor, { data, error }] = useMutation(CREATE_MAJOR, {
    onCompleted: ({ createMajor }) => {
      // console.log(createMajor);
      setLoading(false);
      if (createMajor?.success === true) {
        setAlert(true, "success", createMajor?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createMajor?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  const [updateMajor] = useMutation(UPDATE_MAJOR, {
    onCompleted: ({ updateMajor }) => {
      // console.log(updateMajor);
      setLoading(false);
      if (updateMajor?.success === true) {
        setAlert(true, "success", updateMajor?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", updateMajor?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CreateMajor = Yup.object().shape({
    majorName: Yup.string().required("require!"),
    remark: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      majorName: "",
      remark: "",
    },

    validationSchema: CreateMajor,
    onSubmit: async (values) => {
      // console.log("values:::", values);
      setLoading(true);
      if (dialogTitle !== "Create") {
        updateMajor({
          variables: {
            id: editData?._id,
            input: {
              ...values,
            },
          },
        });
      } else {
        createMajor({
          variables: {
            input: {
              ...values,
            },
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;

  // console.log(editData)

  useEffect(() => {
    if (editData) {
      setFieldValue("majorName", editData?.majorName);
      setFieldValue(
        "remark",
        editData?.remark === null ? "" : editData?.remark
      );
    }
  }, [editData]);

  return (
    <Dialog open={open} className="create-container">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              {dialogTitle} Major
            </Typography>
          </Stack>

          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <CloseIcon className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography className="field-title">Major name</Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder="major name"
                  {...getFieldProps("majorName")}
                  error={Boolean(touched.majorName && errors.majorName)}
                  helperText={touched.majorName && errors.majorName}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography className="field-title">Remark</Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder="remark"
                  {...getFieldProps("remark")}
                  error={Boolean(touched.remark && errors.remark)}
                  helperText={touched.remark && errors.remark}
                />
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>

      <DialogActions>
        <Stack direction="row" spacing={4} className="action-container">
          <Button className="btn-cencel" fullWidth onClick={handleClose}>
            Cencel
          </Button>

          {loading ? (
            <Button className="btn-create" fullWidth>
              Loading...
            </Button>
          ) : (
            <Button className="btn-create" fullWidth onClick={handleSubmit}>
              {dialogTitle}
            </Button>
          )}
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
